import styled from 'styled-components';
import { Logo } from '@kvdbil/components';
import { useTranslation } from 'react-i18next';
import { Language } from '../../Translations';

const Container = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    display: block;
    margin-top: -0.4rem;
    font-size: 0.65rem;
    font-family: 'Next', 'Open Sans', 'Segoe UI', Tahoma, Verdana, sans-serif;
  }
`;

const DisplayBranding = (props: object) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language as Language;

  return (
    <Container {...props}>
      <Logo locale={currentLanguage} />
      <span>{t('Your digital cardealer')}</span>
    </Container>
  );
};

export default DisplayBranding;
